import { Outlet } from 'react-router';

import { AuthShowcase } from '@/features/auth/components/AuthShowcase';

/**
 * Gabarit des écrans d'authentification : formulaire à gauche, panneau de
 * marque à droite.
 *
 * L'écran tient dans la fenêtre, sans défilement :
 *  - `h-dvh` fixe la hauteur à celle du viewport. `dvh` et non `vh` : sur
 *    mobile, `100vh` inclut la barre d'adresse rétractable, ce qui produit
 *    justement le débordement que l'on cherche à éviter.
 *  - `overflow-hidden` supprime la barre de défilement.
 *  - `min-h-0` sur la colonne : sans lui, un élément de grille refuse de
 *    descendre sous la taille intrinsèque de son contenu et déborde malgré tout.
 *
 * La compression réelle est assurée par les espacements fluides en `vh` de
 * `LoginPage` : sur un écran court, les marges se resserrent au lieu de
 * pousser le contenu hors cadre.
 */
export const AuthLayout = () => (
  <div className="grid h-dvh overflow-hidden lg:grid-cols-[minmax(0,1fr)_minmax(0,1.05fr)]">
    <div className="flex min-h-0 flex-col px-6 py-[clamp(1rem,3vh,2.25rem)] sm:px-10 lg:px-14 xl:px-20">
      <Outlet />
    </div>

    <AuthShowcase className="m-4 hidden min-h-0 min-w-0 lg:block xl:m-6" />
  </div>
);
